"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardTipReallocationSchema = exports.TipAllocationSchema = exports.ReallocationOperationSchema = void 0;
const zod_1 = require("zod");
exports.ReallocationOperationSchema = zod_1.z.enum(['void', 'transfer', 'split']);
exports.TipAllocationSchema = zod_1.z.object({
    employeeId: zod_1.z.string().min(1),
    employeeName: zod_1.z.string().min(1),
    amount: zod_1.z.number().positive(),
});
exports.CardTipReallocationSchema = zod_1.z.object({
    reallocationId: zod_1.z.string().min(1),
    tenantId: zod_1.z.string().min(1),
    locationId: zod_1.z.string().min(1),
    businessDate: zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    sourceTransactionId: zod_1.z.string().min(1),
    sourceTransactionNumber: zod_1.z.string().min(1),
    originalEmployeeId: zod_1.z.string().min(1),
    originalEmployeeName: zod_1.z.string().min(1),
    originalTipAmount: zod_1.z.number().positive(),
    operation: exports.ReallocationOperationSchema,
    allocations: zod_1.z.array(exports.TipAllocationSchema),
    note: zod_1.z.string().min(1).max(500),
    createdBy: zod_1.z.string().min(1),
    createdByName: zod_1.z.string().min(1),
    createdAt: zod_1.z.number().int().positive(),
    reversedAt: zod_1.z.number().int().positive().optional(),
    reversedBy: zod_1.z.string().optional(),
    status: zod_1.z.enum(['active', 'reversed']),
});
//# sourceMappingURL=card-tip-reallocation.schema.js.map